import { useTheme } from 'styled-components';

import { Button, ButtonVariant } from '@/components/form/button';
import { useConditionalTranslation } from '@/hooks';

interface IProps {
  id?: string;

  primaryBtnId?: string;

  secondaryBtnId?: string;

  title: string;

  onNewTracking?: () => void;

  variation: 'light' | 'dark';

  onSecondaryButton?: () => void;

  primaryButtonLabel: string;

  secondaryButtonLabel: string;
}

export const DashboardCard: React.FC<IProps> = ({
  id,
  title,
  primaryBtnId,
  secondaryBtnId,
  onSecondaryButton,
  onNewTracking,
  variation,
  primaryButtonLabel,
  secondaryButtonLabel,
}) => {
  const translate = useConditionalTranslation();
  const t: any = useTheme();
  const theme = t.current;

  // decide color of icon based on the background color of the container
  const variationColor = variation === 'light' ? 'black' : 'white';

  return (
    <div className="w-full" id={id}>
      <div
        className={`flex flex-col bg-${theme}-${variation} justify-center items-center rounded-t-[40px] p-12`}
      >
        <DashboardCardIcon color={variationColor} />
        <h1
          className={`font-bold text-[1.75rem] mt-6 text-center text-${variationColor}`}
        >
          {translate(title)}
        </h1>
      </div>
      <div className="flex flex-col lg:flex-row justify-end gap-6 bg-gray p-6 rounded-b-[40px]">
        <Button
          id={secondaryBtnId}
          onClick={onSecondaryButton}
          variant={ButtonVariant.Link}
          classnames={`text-${theme}-primary text-base font-semibold`}
        >
          {translate(secondaryButtonLabel)}
        </Button>
        <Button id={primaryBtnId} onClick={onNewTracking} variant={ButtonVariant.Primary}>
          {translate(primaryButtonLabel)}
        </Button>
      </div>
    </div>
  );
};

const DashboardCardIcon = ({ color }: { color: 'black' | 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59.207"
      height="59.207"
      viewBox="0 0 59.207 59.207"
    >
      <g id="icon_optimization-rocket-graph" transform="translate(0.5 0.707)">
        <g id="Group_3827" data-name="Group 3827" transform="translate(0 0)">
          <path
            id="Path_2909"
            data-name="Path 2909"
            d="M32.239,5.965h0A16.389,16.389,0,0,1,34.12,29.087c-.335.387-.7.748-1.057,1.108h0a17.2,17.2,0,0,1-23.948,0h0A16.469,16.469,0,0,1,4.94,23.442"
            transform="translate(12.228 15.165)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2910"
            data-name="Path 2910"
            d="M10.992,8.743,16.32,3.511h0a2.383,2.383,0,0,1,3.4,0l3.4,3.351v0a2.349,2.349,0,0,1,.026,3.3c-.026,0-.026,0-.052.026L12.84,20.261h0a2.49,2.49,0,0,1-3.016.309"
            transform="translate(26.229 6.079)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2911"
            data-name="Path 2911"
            d="M12.707,11.3l6.932-6.934L15.772.5"
            transform="translate(34.494 -0.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2912"
            data-name="Path 2912"
            d="M18.367,5.367,14.5,1.5"
            transform="translate(39.633 2.367)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2913"
            data-name="Path 2913"
            d="M3.453,10.5H16.987"
            transform="translate(7.966 28.167)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2914"
            data-name="Path 2914"
            d="M4,15.5H40.733"
            transform="translate(9.533 42.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2915"
            data-name="Path 2915"
            d="M9,13.5v7.733"
            transform="translate(23.867 36.767)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2916"
            data-name="Path 2916"
            d="M.5,8.5H21.767"
            transform="translate(-0.5 22.433)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2917"
            data-name="Path 2917"
            d="M2,.5H9.733V31.433H2Z"
            transform="translate(3.8 -0.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_2918"
            data-name="Path 2918"
            d="M6,2.5h7.733V25.7H6Z"
            transform="translate(15.267 5.233)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  );
};
